<template>
  <div class="research-b">
    

    <!-- 内容 -->
    <researchCard
      :path="mydata.path"
      class="research"
      v-for="(item, index) in mydata.articleListArr"
      :key="index"
      :info="item"
    ></researchCard>

    <!-- 空白内容组件 -->
        <!-- <glEmpty
          v-if="mydata.articleListArr.length === 0"
          marginTop="40px"
        ></glEmpty> -->

    <!--分页 -->
    <div class="gl-pagination">
      <el-pagination
        v-model:currentPage="mydata.pageObj.currentPage"
        v-model:page-size="mydata.pageObj.pageSize"
        :total="mydata.pageObj.total"
        layout="prev, pager, next"
        pager-count="4"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>
  
<script setup>
import researchCard from "@/components/researchCard/index.vue";

//引入接口
import { articleList } from "@/api/home/index.js";
// 引入接口
import { getUrlId } from "@/utils/slide.js";

import { reactive } from "vue";

import { useRouter, useRoute } from "vue-router";
const router = useRouter();
const route = useRoute();

const mydata = reactive({
  currentPage3: "5",
  pageSize3: "100",
  small: false,
  background: false,
  disabled: false,

  path: "/layout/list/enterpriseDetails",
  articleListArr: [], // 文章列表

  pageObj: {
    currentPage: 1, // 当前页数
    pageSize: 4, // 每页条数
    total: 0, // 总的条数
  },

  form: {
    // column_id: getUrlId(route.path), // 栏目id值
    column_id: 39, // 栏目id值
    // search: "", // 搜索查询
    // stage: "", //学段
    // theme: "", //主题
    // subject: "", //学科
  },
});

// 当前页数改变事件
function handleCurrentChange(val) {
  // 查询
  articleListFn();
}

// 获取文章列表
function articleListFn() {
  articleList({
    ...mydata.form,
    page: String(mydata.pageObj.currentPage),
    psize: String(mydata.pageObj.pageSize),
  }).then((res) => {
    // 文章列表
    mydata.articleListArr = res.data.list;
    // 总的条数
    mydata.pageObj.total = res.data.count;
  });
}

// 查询列表
// function queryList(dict, inputValue) {
//   // 赋值
//   mydata.form.search = inputValue;
//   // 查询
//   articleListFn();
// }

// 查询
articleListFn();
// //点击事件
// function enterpriseButton() {
//   router.push({
//     path: "/layout/list/enterpriseDetails",
//   });
// }
</script>
  
  <style scoped lang="scss">
.research-b {
  // background-color: #f9f9f9;
  background-color: #ffffff;
  // padding-bottom: 40px;
  // padding-top:16px;

  .big-box.research{
    margin-top:16px;
  }



  //////////分页
  .paging {
    // margin: 0 auto;
    display: flex;
    justify-content: center;
    margin-top: 40px;
    // margin-bottom:40px;
    :deep(.el-button.is-plain) {
      margin-left: 24px;
    }
  }
  //最左边的箭头
  :deep(.btn-prev.is-first) {
    margin-right: 12px;
    background-color: #f5f6f7;
  }
  :deep(.btn-next) {
    background-color: #f5f6f7;
  }
  //每个页
  :deep(.number) {
    margin-right: 12px;
    // color:#BBBDBF;
    background-color: #f5f6f7;
  }
  //省略号
  :deep(.more.btn-quicknext.el-icon) {
    margin-right: 12px;
    background-color: #f9f9f9;
  }

  .demo-pagination-block + .demo-pagination-block {
    margin-top: 10px;
  }
  .demo-pagination-block .demonstration {
    margin-bottom: 16px;
  }
}
</style>
  